import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    class: "fertility-calculator flex flex-col max-w-full"
};
const _hoisted_2 = {
    class: "flex w-full justify-between items-end"
};
const _hoisted_3 = {
    class: "flex gap-[2rem] items-end mt-[3.2rem]"
};
const _hoisted_4 = {
    class: "flex flex-col"
};
const _hoisted_5 = {
    class: "flex flex-col"
};
const _hoisted_6 = {
    class: "mt-4 flex gap-[.8rem] items-end"
};
const _hoisted_7 = [
    "onClick"
];
const _hoisted_8 = {
    key: 0,
    class: "date-line relative mt-[6.4rem]"
};
const _hoisted_9 = {
    class: "flex gap-[.4rem] items-center overflow-x-auto pb-[8.2rem] relative min-h-[18.2rem]"
};
import { ref } from "vue";
import { ElDatePicker, ElInputNumber } from "element-plus";
export default {
    __name: 'CalculatorFertility',
    setup (__props) {
        const lastPeriod = ref("");
        const cycleLength = ref();
        const cycle = ref([
            [],
            [],
            []
        ]);
        const selectedMonth = ref(0);
        const months = ref([]);
        const calculateCycle = ()=>{
            if (!lastPeriod.value) return;
            const startDate = new Date(lastPeriod.value);
            months.value = [];
            cycle.value = [
                [],
                [],
                []
            ];
            for(let m = 0; m < 3; m++){
                const monthStart = new Date(startDate);
                monthStart.setMonth(startDate.getMonth() + m);
                months.value.push(monthStart.toLocaleString('pl-PL', {
                    month: 'long'
                }));
                cycle.value[m] = [];
                const daysInMonth = new Date(monthStart.getFullYear(), monthStart.getMonth() + 1, 0).getDate();
                for(let i = 0; i < daysInMonth; i++){
                    const date = new Date(monthStart);
                    date.setDate(i + 1);
                    let type = "bg-gray-200";
                    const cycleDay = Math.floor((date - startDate) / (1000 * 60 * 60 * 24)) % cycleLength.value;
                    if (cycleDay >= 10 && cycleDay <= 16) type = "low-chance bg-gray-300 h-[10rem]"; // Dni płodne (niska szansa)
                    if (cycleDay >= 12 && cycleDay <= 15) type = "high-chance bg-gray-500 text-white h-[14rem]"; // Dni płodne (wysoka szansa)
                    if (cycleDay === 14) type = "ovulation bg-navy-0 text-white h-[20rem]"; // Owulacja
                    cycle.value[m].push({
                        date,
                        type
                    });
                }
            }
        };
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[2] || (_cache[2] = _createElementVNode("label", {
                                class: "body-tiny font-medium"
                            }, "Data ostatniej miesiączki:", -1)),
                            _createVNode(_unref(ElDatePicker), {
                                modelValue: lastPeriod.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>lastPeriod.value = $event),
                                type: "date",
                                placeholder: "Wybierz datę",
                                format: "YYYY-MM-DD",
                                class: "w-[26rem] mt-[.4rem]"
                            }, null, 8, [
                                "modelValue"
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _cache[3] || (_cache[3] = _createElementVNode("label", {
                                class: "body-tiny font-medium"
                            }, "Długość cyklu (dni):", -1)),
                            _createVNode(_unref(ElInputNumber), {
                                modelValue: cycleLength.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>cycleLength.value = $event),
                                min: 21,
                                max: 35,
                                class: "w-[26rem] mt-[.4rem]",
                                placeholder: "Wybierz długość",
                                controls: false,
                                "controls-position": "right"
                            }, null, 8, [
                                "modelValue"
                            ])
                        ]),
                        _createElementVNode("div", {
                            type: "primary",
                            onClick: calculateCycle,
                            class: "btn btn--primary"
                        }, "Oblicz")
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(months.value, (month, index)=>{
                            return _openBlock(), _createElementBlock("div", {
                                key: index,
                                onClick: ($event)=>selectedMonth.value = index,
                                class: "btn btn--secondary btn--small m-0"
                            }, _toDisplayString(month), 9, _hoisted_7);
                        }), 128))
                    ])
                ]),
                months.value[1] ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cycle.value[selectedMonth.value], (day)=>{
                            return _openBlock(), _createElementBlock("div", {
                                key: day.date,
                                class: _normalizeClass([
                                    "p-[1.4rem] flex items-center justify-center rounded-full body-md min-h-[6rem] max-w-[4rem]",
                                    day.type
                                ])
                            }, _toDisplayString(day.date.getDate()), 3);
                        }), 128))
                    ]),
                    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"legend flex gap-[3.6rem] absolute bottom-[3.2rem] w-full justify-center\"><div class=\"flex gap-[.8rem] body-sm items-center\"><span class=\"flex relative content rounded-full bg-gray-100 w-[1.6rem] h-[1.6rem]\"></span>Początek okresu </div><div class=\"flex gap-[.8rem] body-sm items-center\"><span class=\"flex relative content rounded-full bg-gray-300 w-[1.6rem] h-[1.6rem]\"></span>Dni płodne (niska szansa) </div><div class=\"flex gap-[.8rem] body-sm items-center\"><span class=\"flex relative content rounded-full bg-gray-500 w-[1.6rem] h-[1.6rem]\"></span>Dni płodne (wysoka szansa) </div><div class=\"flex gap-[.8rem] body-sm items-center\"><span class=\"flex relative content rounded-full bg-navy-0 w-[1.6rem] h-[1.6rem]\"></span>Owulacja </div></div>", 1))
                ])) : _createCommentVNode("", true)
            ]);
        };
    }
};
